import { UI, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Pressable } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import { usePrivatePensionAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/PrivatePension';
import { useGlobalProductContext } from '../../../../../contexts';

import { PrivatePensionItemTypes } from '.';

export const PrivatePensionItemMobile: React.FC<PrivatePensionItemTypes.Props> = ({ offer }) => {
  const { setModalOpen, setOfferSelected } = usePrivatePensionAssetContext();
  const { product } = useGlobalProductContext();

  const onOpenDetailsModal = () => {
    setModalOpen(true);
    setOfferSelected({ ...offer, accountId: 0 });
  };

  const middleInfos1 = [
    {
      label: 'Tipo',
      value: <UI.Text color="neutral.dark">{offer.productTypeNormalized}</UI.Text>,
      w: '49%',
    },
    {
      label: 'Mês',
      value: <UI.Text color="neutral.dark">{offer.monthlyRentabilityNormalized}</UI.Text>,
      w: '49%',
    },
  ];

  const middleInfos2 = [
    {
      label: 'Ano',
      value: <UI.Text color="neutral.dark">{offer.annualRentabilityNormalized}</UI.Text>,
      w: '49%',
    },
    {
      label: '12 Meses',
      value: <UI.Text color="neutral.dark">{offer.twelveMonthsRentabilityNormalized}</UI.Text>,
      w: '49%',
    },
  ];

  const middleInfos3 = [
    {
      label: 'Aplic. Min',
      value: <UI.Text color="neutral.dark">{offer.minimumApplicationNormalized}</UI.Text>,
      w: '49%',
    },
    {
      label: 'Data início',
      value: <UI.Text color="neutral.dark">{offer.initialDateNormalized}</UI.Text>,
      w: '49%',
    },
  ];

  const middleInfos4 = [
    {
      label: 'Data de referência',
      value: <UI.Text color="neutral.dark">{offer.referenceDateNormalized}</UI.Text>,
      w: '49%',
    },
  ];

  const infos = [middleInfos1, middleInfos2, middleInfos3, middleInfos4];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack alignItems="center" space={Spacing['inline.quarck']}>
          <Pressable onPress={onOpenDetailsModal}>
            <UI.Icon name="Info" size="xs" />
          </Pressable>
          <UI.Text variant="semibold" color="neutral.black" fontSize={Typography['fontsize.lg']}>
            {offer.productNameNormalized}
          </UI.Text>
        </HStack>
        {infos.map((info, i) => (
          <HStack justifyContent="space-between" key={`infos-${i}`}>
            {info.map(({ label, value, w }) => (
              <VStack w={w} space={Spacing['stack.quarck']} key={label}>
                {!!label && (
                  <UI.Text color="neutral.black" variant="semibold">
                    {label}
                  </UI.Text>
                )}
                {value}
              </VStack>
            ))}
          </HStack>
        ))}
      </VStack>
    </TableContent>
  );
};
